<div #panel class="myp-mention-picker" role="listbox" [attr.aria-label]="'People to mention'" (mousedown)="preventBlur($event)">
  @for (candidate of candidates; track candidate.id; let i = $index) {
    <div class="mention-option" role="option" [id]="optionId(i)" [attr.aria-selected]="candidate.selected ? 'true' : 'false'" [class.selected]="candidate.selected" (click)="select(candidate)">
      <img [src]="candidate.photo || './assets/images/default_avatar.jpg'" class="profile-photo tiny m-r-5" alt="" aria-hidden="true" />
      <span class="mention-option-name">{{ candidate.name }}</span>
    </div>
  }
</div>
